export const expenseTypes = [
    {
        value: "baseYear",
        label: "Base Year",
    },
    {
        value: "nnnExpenseType",
        label: "NNN",
    },
];
